import ReCAPTCHA from 'react-google-recaptcha'
import React, {useEffect, useState} from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from '@ripley-ui/core'
import { Alert } from '@material-ui/lab'
import { ResendEmailStyles } from './styleJss'
import { onPostResendEmail } from '../../model'
import Settings from '../../../../services/Settings'
import PropTypes from "prop-types"

const ResendEmail = ({ country }) => {
  const classes = ResendEmailStyles()

  const [token, setToken] = useState('')
  const [checkedCaptcha, setCheckedCaptcha] = useState(false)
  const [sendButtonEnabled, setSendButtonEnabled] = useState(false)

  const [loading, setLoading] = useState(false)

  const [alert, setAlert] = useState({
    type: '',
    message: null,
  })
  
  const [state, setState] = useState({
    email: '',
    disabled: true,
  })

  useEffect(() => {
    
    const envType = process.env.REACT_APP_ENVIRONMENT_TYPE !== undefined ? process.env.REACT_APP_ENVIRONMENT_TYPE.toString() : ''

    if (envType === 'qa') {
      onChangeCaptcha("token-qa")
      setToken('')
    }

    if (!checkedCaptcha) {
      setSendButtonEnabled(false)
    }else{
      setSendButtonEnabled(true)
    }

  }, [checkedCaptcha])

  const onChangeCaptcha = async (token) => {
    if (!token) {
      setToken('')
      setCheckedCaptcha(false)
      return
    }
    setToken(token)
    setCheckedCaptcha(true)
  }

  const handleSetStateAlert = (validType, error) => {
    setAlert({ ...alert, type: validType, message: error })
  }

  const handleSetState = (context, value) => {
    setState({ ...state, [context]: value, disabled: !value })
  }

  const onResponse = () => {
    handleSetStateAlert(
      'info',
      'En caso de existir email, se reenviara el correo electrónico con los pasos a seguir',
    )
    setLoading(false)
  }

  const onProcess = () => {
    handleSetStateAlert(
      null,
      '',
    )
    setLoading(true)
  }

  const onHandleResendButton = async (email) => {
    try {
      await onPostResendEmail(
        { email: email, country: country },
        token,
        onResponse, 
        onResponse,
        onProcess
      )
    } catch(e) {
      setLoading(false)
    }
  }

  const handleResendButton = async (event) => {
    await onHandleResendButton(state.email)
  }

  return (
    <>
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <img
          src={window.location.origin + '/onboarding/logo-svc.png'}
          alt="Logo seller vendor center"
          width="50%"
          height="50%"
          className={classes.icon}
        ></img>
      </Grid>
      <Box pb={6}>
        <Typography variant="h4" align="center">
          Reenviar correo
        </Typography>
      </Box>

      <Grid container direction="column" justifyContent="center" alignItems="center">
        <Grid item className={classes.wrapItemForm}>
          <TextField
            style={{width: '100%'}}
            id="outlined-email"
            label="Correo electrónico"
            value={state.email}
            onChange={e => handleSetState('email', e.target.value)}
            size="small"
            margin="normal"
            variant="outlined"
            className={classes.textfield}
          />
          {process.env.REACT_APP_ENVIRONMENT_TYPE === 'qa' ? ('') : (
          <Grid item className={classes.wrapItemForm}>
            <ReCAPTCHA 
              style={{width: '100%'}}
              onChange={onChangeCaptcha}
              //ref={recaptchaRef}
              sitekey={Settings.siteKey}
            />
          </Grid>
          )}
        </Grid>
        <Box pb={3}>
          {Boolean(alert.message) && <Alert severity={alert.type}>{alert.message}</Alert>}
        </Box>
        { loading ? 
            <Grid item>
              <CircularProgress/>
            </Grid>
          :
            <Button 
              onClick={handleResendButton} 
              color="primary" 
              variant="contained" 
              className={classes.button} 
              size="large" 
              disabled={loading || !sendButtonEnabled}
            >
              Reenviar
            </Button>
        }
      </Grid>
    </>
  )
}

ResendEmail.propTypes = {
  country: PropTypes.string.isRequired
}

export default ResendEmail
